<template>
    <div class="about">
        <img width="100%" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC.jpg">
<!--
        <div style="color: #666666; font-size: 14px; margin-top: 20px;">益宝成立于2014年11月1日，最初立项于中国社会福利基金会，后于2015年8月独立注册转型为一家社会企业，是中国首家公益人和低保障人群的综合保障服务平台。成立五年来，益宝已累积服务全国30个省市超过8500家公益组织43万余人次，有效提升了公益组织风险应对能力，助力我国普惠金融和精准扶贫事业，最终希望实现“让公益人身有所保心安公益；让保险为所有需要的人可及可信。</div>
        <img width="100%" :src="require('@/assets/about1.jpg')" style="margin-top: 60px">
        <div style="color: #666666; font-size: 14px; margin-top: 20px;">心智宝是由益宝计划发起的，为我国心智障碍者设计推出的专项保险保障项目。成立以来，我们已经为全国超过3万名心智障碍者提供了基本的大病和意外保障，让超过70个家庭在理赔中获益。我们专注于为心智障碍群体提供高性价比的普惠型保险产品和服务，推动人群保障不断完善。</div>
-->
    </div>
</template>

<script>

    import Cookies from 'js-cookie'

    export default {
        data() {
            return {
                type: Cookies.get('type'),
            }
        }
    }
</script>

<style scoped>
    .about {
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
    }
</style>
